import { HttpClient, HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ArticleForUpdateDto, ArticleFournisseurDto, ArticleInfosHeriteesDeLaClassification, ArticlesLexiClient, ArticleType, CaracteristiqueDto, CaracteristiquesLexiClient, ClassificationsLexiClient, CodeAvantagesLexiClient, CompteGeneralDto, CompteGeneralSelectBoxDto, ComptesGenerauxLexiClient, CreateOrUpdateArticleRequestDto, DocumentLexiClient, DocumentResultDto, FormulesLexiClient, GetClassificationDto, GetFormuleDto, GetNoteResult, HistoriquePmpDto, ImagesLexiClient, LieuStockageArticleDto, LieuStockageArticlesLexiClient, LieuStockageDto, LieuStockagesLexiClient, ListSortDirection, NomenclatureCodeAvantageDto, NomenclatureDouaneListDto, NotesLexiClient, ObjectType, Permissions, SocieteToUpdateDto, StockageConnaissement, TarifDto, TarifRevatuaDto, TarifsRevatuaLexiClient, TaxeGroupeDto, TypeVoyage, UniteDto } from "@lexi-clients/lexi";
import { DxFormComponent } from "devextreme-angular";
import { DxoTabPanelOptionsComponent } from "devextreme-angular/ui/nested";
import DataSource from "devextreme/data/data_source";
import { confirm } from 'devextreme/ui/dialog';
import notify from "devextreme/ui/notify";
import { ValidationResult } from "devextreme/ui/validation_group";
import { filter, lastValueFrom, Subscription } from "rxjs";
import { ArticleDetailBonListComponent } from "../../modules/shared/article-detail-bon-list/article-detail-bon-list.component";
import { LieuStockageArticleComponent } from "../../modules/shared/lieux-stockage/lieu-stockage-article/lieu-stockage-article.component";
import { ConfigFiltreLot, LotStockageDatagridComponent } from "../../modules/shared/lot-stockage-datagrid/lot-stockage-datagrid.component";
import { ConfigFiltreMouvement } from "../../modules/shared/mouvement-stock-datagrid/mouvement-stock-datagrid.component";
import { NotificationType } from "../../modules/shared/references/references";
import { ArticleListService } from "../../services/article.service";
import { CodeExonerationListService } from "../../services/code-exoneration.service";
import { ConditionnementListService } from "../../services/conditionnement-list.service";
import { FamilleListService } from "../../services/famille.service";
import { NomenclatureDouaneListService } from "../../services/nomenclature-douane.service";
import { PaysListService } from "../../services/pays.service";
import { SocieteService } from "../../services/societe.service";
import { SuffixeValeurListService } from "../../services/suffixe-valeur.service";
import { TaxeGroupeListService } from "../../services/taxe-groupe.service";
import { UniteListService } from "../../services/unite.service";
import { AuthService } from "../../settings/auth.service";
import { DxDataSourceService } from "../../shared/services/dx-data-source.service";
import { DocumentListComponent } from "../document-list/document-list.component";
import { VariantesArticleListComponent } from "../variantes-article-list/variantes-article-list.component";
import { FormuleListService } from "../../services/formule.service";

@Component({
    selector: "app-article-detail",
    templateUrl: "./article-detail.component.html",
    styleUrls: ["./article-detail.component.scss"],
    standalone: false
})
export class ArticleDetailComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  readonly storedArticleToDuplicateKey = "ARTICLE_A_DUPLIQUER";
  readonly doRefreshKey = "FORCER_RELOAD_ARTICLE_DETAIL";
  @ViewChild("form") form: DxFormComponent;
  @ViewChild("tabPanelGeneralOptions", { static: false }) tabPanelGeneralOptions: DxoTabPanelOptionsComponent;
  @ViewChild(ArticleDetailBonListComponent) articleDetailBonListRef: ArticleDetailBonListComponent;
  @ViewChild(DocumentListComponent) documentListComponentRef: DocumentListComponent;
  @ViewChild(LotStockageDatagridComponent) lotStockageDatagridRef: LotStockageDatagridComponent;
  @ViewChild(LieuStockageArticleComponent) lieuStockageArticleRef: LieuStockageArticleComponent;
  @ViewChild(VariantesArticleListComponent) variantesArticleRef : VariantesArticleListComponent;

  objectType = ObjectType;
  article: ArticleForUpdateDto;
  societe: SocieteToUpdateDto;
  /** Contient les infos héritées d'une classification pour l'article en cours (dont comptes comptables, infos frêt, etc...) */
  infosHeriteesDeLaClassification: ArticleInfosHeriteesDeLaClassification;
  isModificationEnCours: boolean = false;
  isCreation: boolean = false;
  showConfirmationTaxePopup: boolean = false;
  currentSiteId: number;
  currentPartenaireId: number;
  isInterfaceComptableActive: boolean = false;
  chargementInitialFait: boolean = false;
  isImageLoading: boolean = false;
  bonsHasLoaded = false;
  photosLoaded = false;
  referencesFournisseursLoaded = false;
  tarifsDto: TarifDto[];
  notes: GetNoteResult[];
  comptesGeneraux: CompteGeneralSelectBoxDto[];
  codeTarifRevatuaPlaceholder: string;
  stockageRevatuaPlaceholder: string;
  historiquePmp: HistoriquePmpDto[] = [];
  showPopupHistorique: boolean = false;
  articleAvecVariation: boolean = false;
  previousNomenclatureDouaneId: number;
  articleParent: ArticleForUpdateDto;
  classifications: GetClassificationDto[] = [];
  configFiltre = <ConfigFiltreMouvement>{
    isByArticle: true,
    isByPartenaire: true,
    isBySociete: false,
    isByDocumentLogistique: false,
    isByBon: false,
  };
  configFiltreLot = <ConfigFiltreLot>{
    isByPartenaire: JSON.parse(
      sessionStorage.getItem("grille_lot_stockage_fiche_article_by_partenaire"),
    ),
  };
  lieuStockageArticleDataSource: LieuStockageArticleDto[];
  lieuStockageDataSource: LieuStockageDto[];

  tabTitlesEnum = TabTitlesEnum;
  dictionnaireTabTitles: { [key in TabTitlesEnum]: string } = {
    [TabTitlesEnum.Achats]: "Achats",
    [TabTitlesEnum.Audit]: "Audit",
    [TabTitlesEnum.Caracteristiques]: "Caractéristiques",
    [TabTitlesEnum.Classifications]: "Classifications",
    [TabTitlesEnum.ComptaDouane]: "Compta / Douane",
    [TabTitlesEnum.General]: "Général",
    [TabTitlesEnum.Historique]: "Historiques",
    [TabTitlesEnum.Logistique]: "Logistique",
    [TabTitlesEnum.NumeroSerie]: "Numéro de série",
    [TabTitlesEnum.Stock]: "Stock",
    [TabTitlesEnum.Variantes]: "Variantes",
    [TabTitlesEnum.Vente]: "Vente",
    [TabTitlesEnum.Documents]: "Documents",
    [TabTitlesEnum.Photos]: "Photos",
    [TabTitlesEnum.Association]: "Associations",
    [TabTitlesEnum.Revatua]: "Revatua",
  }

  readonly actions = [
    { id: "edit", intitule: "Modifier" },
    { id: "dupliquer", intitule: "Dupliquer" },
  ];

  readonly articleTypeDataSource: Array<{ id: ArticleType, libelle: string }> =
  [
    { id: ArticleType.backOffice, libelle: "Stockable" },
    { id: ArticleType.commentaire, libelle: "Commentaire" },
    { id: ArticleType.metadata, libelle: "Metadata" },
    { id: ArticleType.kit, libelle: "Kit" },
    { id: ArticleType.prestation, libelle: "Service" },
    { id: ArticleType.interne, libelle: "Interne" },
    { id: ArticleType.libre, libelle: "Libre" },
    { id: ArticleType.generique, libelle: "Générique" },
    { id: ArticleType.fret, libelle: "Frêt" },
    { id: ArticleType.assurance, libelle: "Assurance" },
    { id: ArticleType.bundle, libelle: "Bundle" },
  ];
  // Acces à l'enum côté html
  ArticleType = ArticleType;

  /** DataSource de la dataGrid de l'onglet 'Achats' */
  referencesFournisseurs: ArticleFournisseurDto[];

  // DataSources liées aux SelectBox
  uniteDataSource: UniteDto[] = [];
  conditionnementDataSource: DataSource;
  taxeGroupeDataSource: DataSource;
  preparationZonesDataSource: DataSource;
  tarifRevatuaDataSource: TarifRevatuaDto[];
  codesAvantagesAllerDataSource: NomenclatureCodeAvantageDto[];
  codesAvantagesRetourDataSource: NomenclatureCodeAvantageDto[];
  articleAssuranceDataSource: DataSource;

  // DataSources liées aux SelectBox de l'onglet 'Classifications'
  familleDataSource: DataSource;
  articleDataSource: DataSource;

  // DataSources liées aux SelectBox de l'onglet 'Achats'
  partenaireDataSource: DataSource;

  // DataSources liées aux SelectBox de l'onglet 'Douane'
  nomenclatureDouaneDataSource: DataSource;
  suffixeValeurDataSource: DataSource;
  codeExonerationDataSource: DataSource;
  paysDataSource: DataSource;
  formuleDataSource : DataSource;
  isModificationAutorisee: boolean = false;
  canGererBonAchat: boolean = false;
  canModifierPrixRevient: boolean = false;
  showEditPrixRevientPopup: boolean = false;
  prixRevientAvantModification: number;
  stockageRevatuaList = [
    { id: StockageConnaissement.cale, intitule: "Cale" },
    { id: StockageConnaissement.refrigere, intitule: "Réfrigérée" },
    { id: StockageConnaissement.congele, intitule: "Congelé" },
    { id: StockageConnaissement.pontee, intitule: "Pontée" },
  ];

  //Data sources liées aux photos de l'article
  listPhotos: DocumentResultDto[] = [];
  photoPrincipaleId: string | null;
  addedPhotos: File[] = [];
  selectedPhotoId: string;
  imageSrc: string | null;
  urlPhoto = window.location.origin + "/api/images/";

  uniteBaseSelectedId: number;
  caracteristiqueDataSource: CaracteristiqueDto[] = [];
  isClassificationsDuParent = false;
  showPopover = false;
  caracteristiqueVariation1: string;
  caracteristiqueVariation2: string;
  hasVariation1 : boolean;
  hasVariation2 : boolean;

  //Variables de controle des Tabs du DevExtremeTabPanel
  isTabLoaded: { [key: string]: boolean } = {};

  constructor(
    private readonly http: HttpClient,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly articlesLexiClient: ArticlesLexiClient,
    private readonly taxeGroupeService: TaxeGroupeListService,
    private readonly conditionnementService: ConditionnementListService,
    private readonly familleService: FamilleListService,
    private readonly uniteService: UniteListService,
    private readonly paysService: PaysListService,
    private readonly articleService: ArticleListService,
    private readonly formuleService : FormuleListService,
    private readonly tarifsRevatuaLexiClient: TarifsRevatuaLexiClient,
    private readonly nomenclatureDouaneService: NomenclatureDouaneListService,
    private readonly suffixeValeurService: SuffixeValeurListService,
    private readonly codeExonerationService: CodeExonerationListService,
    private readonly authService: AuthService,
    private readonly societeService: SocieteService,
    private readonly compteGenerauxLexiClient: ComptesGenerauxLexiClient,
    private readonly dxDataSourceService: DxDataSourceService,
    private readonly classificationsLexiClient: ClassificationsLexiClient,
    private readonly documentService: DocumentLexiClient,
    private readonly imageLexiClient: ImagesLexiClient,
    private readonly lieuStockageLexiClient: LieuStockagesLexiClient,
    private readonly lieuStockageArticleLexiClient: LieuStockageArticlesLexiClient,
    private readonly caracteristiquesLexiClient: CaracteristiquesLexiClient,
    private readonly codeAvantagesLexiClient: CodeAvantagesLexiClient,
    private readonly notesLexiClient: NotesLexiClient,
    private readonly formulesLexiClient: FormulesLexiClient
  ) {}

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async (params) => {
      try {
        this.chargementInitialFait = false;
        this.isImageLoading = true;
        const articleId = params["id"];

        this.isModificationAutorisee = this.authService.securityUserisGrantedWith(
          Permissions.canModifierFicheArticle,
        );
        this.canGererBonAchat = this.authService.securityUserisGrantedWith(
          Permissions.administrationBonsAchat,
        );
        this.canModifierPrixRevient = this.authService.securityUserisGrantedWith(
          Permissions.canModifierPrixRevientArticle,
        );

        // Création d'un nouvel article
        if (isNaN(Number(articleId))) {
          // Mauvais paramètre, on redirige sur la page de création d'un nouvel article
          if (articleId != "nouveau") {
            await this.router.navigate(["/article/nouveau"]);
            return;
          }
          this.isCreation = true;
          this.setNewArticle();
          
          // Chargement des éditeurs en parallèle pour la création
          await this.loadEditors();
        }
        // Modificatifon d'un article existant
        else {
          this.isCreation = false;
          
          // PARALLÉLISATION DES APPELS PRINCIPAUX ✅
          await Promise.all([
            this.setArticle(articleId),
            this.loadEditors(),
            this.setTarifsDto(articleId),
            this.setNotes(articleId)
          ]);
        }

        this.lotStockageDatagridRef?.setDataSource();
        
        // Photos et données secondaires chargées uniquement si nécessaire
        if (!this.isCreation) {
          this.photosLoaded = false; // Flag pour lazy loading
          this.referencesFournisseursLoaded = false; // Flag pour lazy loading
          this.setCaracteristiqueVariation();
        }
      }
      finally {
        this.isImageLoading = false;
        this.chargementInitialFait = true;
      }
    });

    this.subscriptions.add(
      this.authService.currentSiteId$
        .pipe(filter((siteId: number) => siteId != null))
        .subscribe((siteId: number) => {
          this.currentSiteId = siteId;
          this.currentPartenaireId = this.authService.currentSite.partenaireId;
        }),
    );

    this.subscriptions.add(
      this.societeService.currentSociete$
        .pipe(filter((societe: SocieteToUpdateDto) => societe != null))
        .subscribe(async (societe: SocieteToUpdateDto) => {
          this.societe = societe;
          this.isInterfaceComptableActive =
            societe.parametrageComptable?.interfaceActive ?? false;
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async setClassifications() {
    let allClassifications = await lastValueFrom(
      this.classificationsLexiClient.getByItemId(this.objectType.article, this.article.id)
    );

    // Si c'est une variante sans classification, récupérer celles du parent
    if (allClassifications.length == 0 && this.article.articleParentId != null) {
      allClassifications = await lastValueFrom(
        this.classificationsLexiClient.getByItemId(this.objectType.article, this.article.articleParentId)
      );
      this.isClassificationsDuParent = allClassifications.length > 0;
    }
    else {
      this.isClassificationsDuParent = false;
    }

    this.classifications = allClassifications.filter(c =>
      c.classificationTypeId == this.societe.classificationSavId
      || c.classificationTypeId == this.societe.classificationComptableTypeId
    );
  }

  async setTarifsDto(articleId: number) {
    this.tarifsDto = await lastValueFrom(this.articlesLexiClient.getTarifsByArticleId(articleId));
  }

  async setNotes(articleId: string) {
    if (this.objectType == null || articleId == null) return;
    this.notes = await lastValueFrom(this.notesLexiClient.getNotes(this.objectType.article, articleId, ListSortDirection.descending));
  }

  async loadEditors() {
    // DataSources synchrones (pas d'attente)
    this.taxeGroupeDataSource = this.dxDataSourceService.getDataSourceForSelectBox(this.taxeGroupeService);
    this.nomenclatureDouaneDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.nomenclatureDouaneService);
    this.comptesGeneraux = await lastValueFrom(this.compteGenerauxLexiClient.getComptesNiveau2PourSelectBox());
    const articleAssuranceParams = new Map().set("articleType", ArticleType.assurance).set("exclureParents", true);
    this.articleAssuranceDataSource = this.dxDataSourceService.getDataSourceForSelectBox(this.articleService, articleAssuranceParams);
    this.formuleDataSource = this.dxDataSourceService.getDataSourceForSelectBox(this.formuleService);
    // PARALLÉLISATION DES APPELS API ✅
    const [unitesResult, tarifsRevatua, comptesGeneraux, caracteristiques] = await Promise.all([
      lastValueFrom(this.uniteService.get(new HttpParams())),
      lastValueFrom(this.tarifsRevatuaLexiClient.getAll()),
      lastValueFrom(this.compteGenerauxLexiClient.getAll()),
      lastValueFrom(this.caracteristiquesLexiClient.getCaracteristiquesByObjectType(ObjectType.article)),
    ]);

    // Assignation des résultats
    this.uniteDataSource = unitesResult?.data ?? [];
    this.tarifRevatuaDataSource = tarifsRevatua;
    this.comptesGeneraux = comptesGeneraux;
    this.caracteristiqueDataSource = caracteristiques;

    // Traitement spécifique selon le mode
    if (!this.isCreation) {
      const conditionnementAdditionalParams = new Map().set("articleId", this.article?.id);
      this.conditionnementDataSource = this.dxDataSourceService.getDataSourceForSelectBox(
        this.conditionnementService,
        conditionnementAdditionalParams,
      );
      // Les références fournisseurs seront chargées en lazy loading
    } else {
      // Par défaut on prend l'Unité "Unité" qui a pour code "U" ou "UN".
      const uniteParDefaut = this.uniteDataSource.find(u => u.codeBo === 'U' || u.codeBo === 'UN');
      this.uniteBaseSelectedId = uniteParDefaut?.id ?? this.uniteDataSource[0]?.id;
      this.article.uniteBaseId = this.uniteBaseSelectedId;
    }
  }

  async setReferencesFournisseurs() {
    this.referencesFournisseurs = await lastValueFrom(
      this.articlesLexiClient.getReferencesFournisseurByArticleId(
        this.article?.id,
      ),
    );
  }

  // MÉTHODES LAZY LOADING ✅
  private async loadPhotosLazy() {
    if (!this.photosLoaded) {
      try {
        await this.getListPhotos();
        await this.loadPhotoPrincipale();
        this.photosLoaded = true;
      } catch (error) {
        console.error('Erreur lors du chargement des photos:', error);
      }
    }
  }

  private async loadReferencesFournisseursLazy() {
    if (!this.referencesFournisseursLoaded && !this.isCreation) {
      try {
        await this.setReferencesFournisseurs();
        this.referencesFournisseursLoaded = true;
      } catch (error) {
        console.error('Erreur lors du chargement des références fournisseurs:', error);
      }
    }
  }

  private setNewArticle() {
    if (localStorage.getItem(this.doRefreshKey)) {
      localStorage.removeItem(this.doRefreshKey);
      window.location.reload(); // Nécessaire pour rafraîchir la vue correctement (notamment le bouton "Créer")
      return;
    }

    const storedArticle = localStorage.getItem(
      this.storedArticleToDuplicateKey,
    );
    if (storedArticle) {
      this.article = JSON.parse(storedArticle);
      delete this.article.id;
      this.article.codeBo = null;
      localStorage.removeItem(this.storedArticleToDuplicateKey);
    } else {
      this.article = {
        suiviSav: false,
        typeArticle: "",
        type: ArticleType.backOffice,
        bloque: false,
        quantiteMinimumVente: 1,
        rapportTarifaire: 1,
        rapportPhysique: 1,
        nombreNumeroSerie: 0,
        _synchronized: false,
        isPgc: false,
        isPpn: false,
        uniteBaseId: this.uniteBaseSelectedId,
      };
    }
  }

  private async setArticle(articleId: number) {
    // PARALLÉLISATION - Chargement article + infos héritées ✅
    const [article, infosHeritees] = await Promise.all([
      lastValueFrom(this.articlesLexiClient.getForUpdate(articleId)),
      lastValueFrom(this.articlesLexiClient.getInfosHeriteesDeLaClassification(articleId))
    ]);

    this.article = article;
    this.articleAvecVariation = this.article.avecVariation;
    this.photoPrincipaleId = this.article.photoPrincipaleId;
    this.uniteBaseSelectedId = this.article.uniteBaseId;

    // Si article parent, charger ses infos héritées
    if (this.article.articleParentId != null) {
      this.infosHeriteesDeLaClassification = await lastValueFrom(
        this.articlesLexiClient.getInfosHeriteesDeLaClassification(this.article.articleParentId)
      );
    } else {
      this.infosHeriteesDeLaClassification = infosHeritees;
    }

    // Chargement article parent si nécessaire (plus de doublon tarifsRevatua car déjà chargé dans loadEditors)
    if (this.article.articleParentId != null) {
      this.articleParent = await lastValueFrom(this.articlesLexiClient.getForUpdate(this.article.articleParentId));
    }

    // Chargement codes avantages si nomenclature douane présente ✅
    if (this.article != null && this.article.nomenclatureDouaneId != null) {
      const [codesAller, codesRetour] = await Promise.all([
        lastValueFrom(this.codeAvantagesLexiClient.getByNomenclatureAndTypeVoyage(this.article.nomenclatureDouaneId, TypeVoyage.aller)),
        lastValueFrom(this.codeAvantagesLexiClient.getByNomenclatureAndTypeVoyage(this.article.nomenclatureDouaneId, TypeVoyage.retour))
      ]);
      this.codesAvantagesAllerDataSource = codesAller;
      this.codesAvantagesRetourDataSource = codesRetour;
    }

    // Set placeholder CodeTarifRevatua
    if (this.tarifRevatuaDataSource != null){
      const tarifRevatua = this.tarifRevatuaDataSource.find(
        (x) => x.id == this.infosHeriteesDeLaClassification?.codeTarifRevatua,
      );
      this.codeTarifRevatuaPlaceholder = this.codeTarifRevatuaDisplayExpr(tarifRevatua);
    }

    // Set placeholder StockageRevatua
    if (
      this.article != null &&
      this.infosHeriteesDeLaClassification?.stockageRevatua != null
    ) {
      const stockageRevatua = this.stockageRevatuaList.find(
        (x) => x.id == this.infosHeriteesDeLaClassification?.stockageRevatua,
      );
      this.stockageRevatuaPlaceholder = stockageRevatua?.intitule;
    }
  }

  prixArticleEditorOptions: any = {
    icon: "edit",
    onClick: () => (this.showEditPrixRevientPopup = true),
  };

  opentPrixRevientPopup() {
    this.showEditPrixRevientPopup = true;
    this.prixRevientAvantModification = this.article.prixRevient;
  }

  async onUpdatePrixRevient() {
    await lastValueFrom(
      this.articlesLexiClient.updatePrixRevient(
        this.article.id,
        this.article.prixRevient,
      ),
    );
    this.showEditPrixRevientPopup = false;
  }

  async navigateToArticleParent() {
    if (!this.article.articleParentId) return;
    await this.router.navigate([`/article/${this.article.articleParentId}`]);
  }

  //#region Gestion des photos
  async getListPhotos() {
    const documents = await this.getDocuments();
    this.listPhotos = documents.filter(
      (x) =>
        x.contentType === ".png" ||
        x.contentType === ".jpeg" ||
        x.contentType === ".jpg",
    );
  }

  async addNewImage() {
    const formData = new FormData();
    const articleId = this.article.id.toString();
    var addedPhoto = this.addedPhotos;
    if (addedPhoto && addedPhoto.length > 0) {
      formData.append("ArticleId", articleId);
      formData.append("Files", addedPhoto[0]);

      // Effectuer la requête HTTP
      await this.http
        .post(window.location.origin + "/api/Images", formData)
        .toPromise();
      await this.getListPhotos();
      await this.loadPhotoPrincipale();

      // On rafraichit la liste des documents (sans attendre la fin de l'appel)
      this.documentListComponentRef?.setDocuments();
    }
    this.addedPhotos = [];
  }

  async loadPhotoPrincipale() {
    if (this.photoPrincipaleId == null) {
      this.photoPrincipaleId = this.listPhotos
        ?.slice()
        .sort((a, b) => a.zIndex - b.zIndex)[0]?.id;
    }
    this.selectedPhotoId = this.photoPrincipaleId;
    await this.showSelectedPhoto();
  }

  async onDocumentSupprime(documentSupprimeId: string) {
    await this.getListPhotos();

    // La photo principale a été supprimée
    if (documentSupprimeId == this.photoPrincipaleId) {
      this.photoPrincipaleId = null;
      await this.loadPhotoPrincipale();

      if (this.selectedPhotoId != null) {
        await this.changePhotoPrincipale();
      }
    }
  }

  async changePhotoPrincipale() {
    const newPhoto = {
      id: this.selectedPhotoId,
      objectId: this.article.id.toString(),
      objectType: ObjectType.article,
    };
    await lastValueFrom(
      this.imageLexiClient.changerPhotoPrincipale(
        newPhoto.id,
        newPhoto.objectId,
        newPhoto.objectType,
      ),
    );
    this.photoPrincipaleId = this.selectedPhotoId;
  }

  async showSelectedPhoto() {
    this.imageSrc =
      window.location.origin + "/api/images/" + this.selectedPhotoId;
  }
  //#endregion

  //#region Gestion des évènements

  onTabSelectionChanged = (e) => {
    const title = e?.addedItems?.[0]?.title;
    if (!this.isTabLoaded[title]) {
      this.isTabLoaded[title] = true;
    }
    switch (title) {
      case this.dictionnaireTabTitles[TabTitlesEnum.Classifications]:
        this.setTabClassificationsDataSources();
        break;
      case this.dictionnaireTabTitles[TabTitlesEnum.Achats]:
        this.setTabAchatsDataSources();
        // LAZY LOADING DES RÉFÉRENCES FOURNISSEURS ✅
        this.loadReferencesFournisseursLazy();
        break;
      case this.dictionnaireTabTitles[TabTitlesEnum.ComptaDouane]:
        this.setTabDouaneDataSources();
        break;
      case this.dictionnaireTabTitles[TabTitlesEnum.Logistique]:
        this.setLieuStockageArticleDataSource();
        this.setLieuStockageDataSource();
        break;
      case this.dictionnaireTabTitles[TabTitlesEnum.Photos]:
        // LAZY LOADING DES PHOTOS ✅
        this.loadPhotosLazy();
        break;
      default:
        break;
    }
  };

  private async setLieuStockageArticleDataSource() {
    if (this.lieuStockageArticleRef == null) return;
    this.lieuStockageArticleRef.lieuStockageArticleDataSource ??= await lastValueFrom(this.lieuStockageArticleLexiClient.getByArticleId(this.article.id));
  }

  private async setLieuStockageDataSource() {
    if (this.lieuStockageArticleRef == null) return;
    this.lieuStockageArticleRef.lieuStockageSociete ??= await lastValueFrom(this.lieuStockageLexiClient.rechercher(null, this.authService.currentSociete?.id));
    this.lieuStockageArticleRef.setLieuStockage();
  }

  async onActionClick(e: any) {
    if (e.itemData.id == "edit") {
      this.isModificationEnCours = true;
      await this.getListPhotos();
    } else if (e.itemData.id == "dupliquer") {
      await this.onDuplicateArticle();
    }
  }

  private async onDuplicateArticle() {
    localStorage.setItem(this.doRefreshKey, "true");
    localStorage.setItem(
      this.storedArticleToDuplicateKey,
      JSON.stringify(this.article),
    );
    await this.router.navigate(["/article/nouveau"]);
  }

  async onCreateNewArticle() {
    this.showConfirmationTaxePopup = this.article.taxeGroupeId == null;

    if (!this.showConfirmationTaxePopup) {
      await this.createArticle();
    }
  }

  onTypeSelectionChanged = async (e: { selectedItem: { id: ArticleType, libelle: string } }) => {
    if (e.selectedItem?.id == ArticleType.fret && this.article.taxeGroupeId == null) {
      const taxeGroupes: TaxeGroupeDto[] = await this.taxeGroupeDataSource.load();
      const taxeGroupeExo = taxeGroupes?.find(x => x.codeBo != null && x.codeBo.trim().toUpperCase() == "E");
      this.article.taxeGroupeId = taxeGroupeExo.id;
    }
  }

  async createArticle() {
    // On empêche la création si les validations des comptes ne sont pas valides
    const formValidationResult: ValidationResult =
      this.form.instance.validate();
    if (!formValidationResult.isValid) return;

    const requestDto: CreateOrUpdateArticleRequestDto = {
      article: this.article,
      reporterModificationsSurVariantes: false
    };
    const newArticleId = await lastValueFrom(this.articlesLexiClient.createOrUpdate(requestDto));
    notify(
      { closeOnClick: true, message: "Article créé avec succès." },
      NotificationType.Success,
    );
    await this.router.navigate([`/article/${newArticleId}`]);
    window.location.reload();
  }

  async onUpdateArticle() {
    // On empêche la création si les validations des comptes ne sont pas valides
    const formValidationResult: ValidationResult =
      this.form.instance.validate();
    if (!formValidationResult.isValid) return;

    let reporterModificationsSurVariantes: boolean = false;
    if (this.articleAvecVariation) {
      reporterModificationsSurVariantes = await confirm(`Souhaitez-vous reporter les changements sur les variantes de cet article ?`, `Confirmation`);
    }
    const requestDto: CreateOrUpdateArticleRequestDto = {
      article: this.article,
      reporterModificationsSurVariantes
    };
    await lastValueFrom(this.articlesLexiClient.createOrUpdate(requestDto));

    if (this.selectedPhotoId != this.photoPrincipaleId) {
      await this.changePhotoPrincipale();
    }

    this.articleAvecVariation = this.article.avecVariation;
    this.isModificationEnCours = false;
    if(this.articleAvecVariation){
      await this.variantesArticleRef.setVariantes();
      await this.variantesArticleRef.setCaracteristiquesValeurs();
    }
    notify({ closeOnClick: true, message: "Article modifié avec succès." }, NotificationType.Success);
    await this.getListPhotos();
  }

  async onCancel() {
    this.isModificationEnCours = false;
    this.isImageLoading = true;
    await this.setArticle(this.article?.id);
    await this.loadPhotoPrincipale();
    this.isImageLoading = false;
  }

  async onClassificationsMisesAJour(e: GetClassificationDto[]) {
    this.classifications = e.filter(c =>
      c.classificationTypeId == this.societe.classificationSavId
      || c.classificationTypeId == this.societe.classificationComptableTypeId
    );
    this.isClassificationsDuParent = this.classifications.length > 0 && !this.classifications.some(x => x.type == ObjectType.article && x.itemId == this.article.id);

    // Si on supprime la dernière classification de la variante, on essaie de récupérer celles du parent
    if (e.length == 0 && this.article.articleParentId != null) {
      await this.setClassifications();
    }
  }
  //#endregion

  //#region Méthodes helpers
  private setTabClassificationsDataSources() {
    this.familleDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.familleService);
    const articleParams = new Map().set("exclureVariantes", true);
    this.articleDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.articleService, articleParams);
  }

  private setTabAchatsDataSources() {
    this.partenaireDataSource ??= this.dxDataSourceService.getPartenaireDataSourceForSelectBox(true);
  }

  private setTabDouaneDataSources() {
    this.suffixeValeurDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.suffixeValeurService);
    this.codeExonerationDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.codeExonerationService);
    this.paysDataSource ??= this.dxDataSourceService.getDataSourceForSelectBox(this.paysService);
  }

  codeTarifRevatuaDisplayExpr(data: TarifRevatuaDto) {
    return data && `${data.code} - ${data.intitule}`;
  }

  nomenclatureDouaneDisplayExpr(data: NomenclatureDouaneListDto) {
    return data && `${data.codeSH} - ${data.intitule}`;
  }

  compteGeneralDisplayExpr(data: CompteGeneralSelectBoxDto) {
    if (!data) {
      return "";
    }
    return data.code ? `${data.code} - ${data.intitule}` : data.intitule;
  }

  onNomenclatureDouaneChanged= async (e) =>  {
    if (e.previousValue != null) {
      this.previousNomenclatureDouaneId = e.previousValue
    }
    if (e.value != this.previousNomenclatureDouaneId) {  
      let result = confirm(
        `La modification de la nomenclature douanière va modifier le paramétrage Revatua de l'article (Code avantage). Souhaitez-vous continuer ?`,
        "Confirmation"
      );
      result.then(async (dialogResult) => {
        if (dialogResult) {
          this.codesAvantagesAllerDataSource = await lastValueFrom(this.codeAvantagesLexiClient.getByNomenclatureAndTypeVoyage(e.value, TypeVoyage.aller));
          this.codesAvantagesRetourDataSource = await lastValueFrom(this.codeAvantagesLexiClient.getByNomenclatureAndTypeVoyage(e.value, TypeVoyage.retour));
          this.article.codeAvantageAllerId = null;
          this.article.codeAvantageRetourId = null;    
        }
        else {
          e.value = this.previousNomenclatureDouaneId;
        }
      });
    }
  }

  async getDocuments() {
    const documentFiltres = {
      objectId: this.article.id.toString(),
    };

    // Get Documents
    return await lastValueFrom(
      this.documentService.rechercher(documentFiltres),
    );
  }

  async loadHistorique(): Promise<void> {
    this.historiquePmp = await lastValueFrom(this.articlesLexiClient.getHistorique(this.article.id));
    this.showPopupHistorique = true;
  }

  setCaracteristiqueVariation() {
    this.caracteristiqueVariation1 = this.caracteristiqueDataSource.find(x => x.id == this.article.variation1CaracteristiqueId)?.intitule;
    this.caracteristiqueVariation2 = this.caracteristiqueDataSource.find(x => x.id == this.article.variation2CaracteristiqueId)?.intitule;
    this.hasVariation1 = this.article.variation1CaracteristiqueId != null;
    this.hasVariation2 = this.article.variation2CaracteristiqueId != null;
  }

  formuleDisplayExpr(data: GetFormuleDto) {
    return data?.intitule;
  }

  async navigateToFormule() {
    await this.router.navigate(['/formules']);
  }

  //#endregion
}

export enum TabTitlesEnum {
  General,
  Variantes,
  Vente,
  ComptaDouane,
  Stock,
  Achats,
  Logistique,
  NumeroSerie,
  Historique,
  Caracteristiques,
  Classifications,
  Audit,
  Documents,
  Photos,
  Association,
  Revatua,
}